import type {AddTaskFormPayload} from "./add-task.schema";
import type {CreateTaskRequest} from "@project/sdk/admin";

export const addTaskMapper = {
  toSdk: (payload: AddTaskFormPayload): CreateTaskRequest => ({
    title: payload.title,
    status: payload.status,
    dueAt: payload.dueAt,
  }),
};
